import React from "react";
import "../assests/CSS/AboutComponent1.css";
import { aboutData } from "./data";

const AboutComponent1 = () => {
  return (
    <section
      className="about-section"
      style={{
        backgroundImage: `url(${aboutData.backgroundImage})`,
      }}
    >
      <div className="about-content">
        <h1 className="about-title">
          {/* {aboutData.title} */}
          <span style={{ color: "#000", fontWeight: "bold" }}>Thhiya</span><span style={{ color: "red", fontSize: "3rem" , paddingRight:"0.5rem" }}>.</span>
          {/* <span className="red-dot">.</span>{" "} */}
          <span className="bold-subtitle">{aboutData.subtitle}</span>
        </h1>

        <h2 className="about-tagline">{aboutData.tagline}</h2>
        
        <p className="about-description"><span style={{ color: "#000", fontWeight: "bold" }}>Thhiya</span><span style={{ color: "red", fontSize: "2rem", lineHeight: "0.5", paddingRight:"0.5rem" }}>.</span>{aboutData.description}</p>
      </div>
    </section>
  );
};

export default AboutComponent1;
